import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForestRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 758,
	height: 173,
	fill: "none",
	viewBox: "0 0 758 173",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M590.057 86.072a.77.77 0 0 1 .65-.79l3.863-.617a.773.773 0 0 1 .894.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m608.107 56.141-32.653 1.114c-1.021.035-1.595-1.177-.926-1.95 2.267-2.615 6.17-7.245 8.644-10.867 2.436-3.567 5.347-8.88 6.805-11.614a1.184 1.184 0 0 1 2.026-.098c1.731 2.604 5.178 7.698 7.891 11.142 2.683 3.404 6.727 7.83 9.028 10.303.682.733.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m568.956 71.841 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.159 1.159 0 0 1-.726 1.913l-22.205 2.824a1 1 0 0 1-.213.007l-22.51-1.299a1.159 1.159 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M617.049 83.226c-21.527 4.874-26.769 6.026-48.749 1.7a1.156 1.156 0 0 1-.619-1.927l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.705-.03l13.018 13.617 11.994 9.975c.739.614.449 1.81-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M672.625 70.31a.77.77 0 0 1 .65-.79l3.862-.617a.773.773 0 0 1 .895.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.773.773 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m690.675 40.38-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.266-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.731 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.028 10.303.682.733.185 1.937-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m651.524 56.08 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.483a1.16 1.16 0 0 1-.726 1.914L675.1 59.234a1 1 0 0 1-.213.008l-22.511-1.299a1.159 1.159 0 0 1-.852-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M699.617 67.465c-21.528 4.874-26.769 6.026-48.749 1.7a1.156 1.156 0 0 1-.619-1.927l10.226-10.828 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.019 13.617 11.993 9.975c.739.614.45 1.81-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M709.645 61.215a.773.773 0 0 1 .65-.79l3.863-.616a.773.773 0 0 1 .894.736l.245 7.166a.773.773 0 0 1-.746.8l-3.879.131a.77.77 0 0 1-.799-.745z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m727.696 31.285-32.653 1.113c-1.021.035-1.596-1.176-.927-1.949 2.267-2.616 6.171-7.246 8.645-10.868 2.436-3.566 5.346-8.88 6.804-11.613a1.185 1.185 0 0 1 2.027-.099c1.731 2.604 5.177 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.027 10.304.682.732.186 1.936-.814 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m688.544 46.985 21.509-28.008a1.16 1.16 0 0 1 1.791-.058l23.207 26.484a1.159 1.159 0 0 1-.725 1.913L712.12 50.14q-.105.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M736.637 58.37c-21.527 4.874-26.769 6.026-48.749 1.7a1.156 1.156 0 0 1-.618-1.927l10.226-10.828 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.018 13.617 11.994 9.975c.739.614.45 1.81-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M653.479 41.887a.773.773 0 0 1 .65-.79l2.222-.354a.773.773 0 0 1 .894.736l.153 4.488a.773.773 0 0 1-.746.799l-2.231.076a.773.773 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m665.253 20.872-21.119.72c-1.021.035-1.596-1.18-.931-1.955 1.605-1.873 3.939-4.686 5.477-6.939 1.549-2.267 3.373-5.548 4.451-7.55.421-.783 1.539-.838 2.033-.098 1.278 1.91 3.431 5.06 5.157 7.251 1.674 2.125 4.11 4.822 5.75 6.597.68.735.182 1.94-.818 1.974"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m639.189 31.247 14.305-18.628a1.16 1.16 0 0 1 1.791-.059l15.436 17.615a1.159 1.159 0 0 1-.725 1.914l-14.769 1.878q-.106.013-.213.007l-14.973-.864a1.159 1.159 0 0 1-.852-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "M671.558 39.859c-14.198 3.212-18.065 3.966-32.603 1.147-.893-.173-1.247-1.265-.623-1.926l6.683-7.076 8.735-9.829a1.16 1.16 0 0 1 1.705-.03l8.798 9.202 7.799 6.487c.739.615.443 1.812-.494 2.024"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M633.225 68.58a.773.773 0 0 1 .65-.789l3.863-.617a.773.773 0 0 1 .894.737l.245 7.166a.774.774 0 0 1-.746.799l-3.879.132a.773.773 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m651.275 38.65-32.653 1.114c-1.021.035-1.595-1.177-.926-1.949 2.267-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.731 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.028 10.303.682.733.185 1.937-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m612.124 54.35 21.508-28.007a1.16 1.16 0 0 1 1.791-.058l23.208 26.483a1.16 1.16 0 0 1-.726 1.914L635.7 57.505a1 1 0 0 1-.213.008l-22.51-1.299a1.159 1.159 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M660.217 65.736c-21.527 4.874-26.769 6.026-48.749 1.7a1.156 1.156 0 0 1-.619-1.927l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.704-.03l13.019 13.617 11.993 9.975c.74.614.45 1.81-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M684.071 59.873a.773.773 0 0 1 .65-.79l1.972-.315a.773.773 0 0 1 .894.737l.139 4.08a.77.77 0 0 1-.746.799l-1.98.067a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m694.889 40.215-19.362.66c-1.021.036-1.596-1.18-.932-1.957 1.493-1.746 3.596-4.29 4.995-6.339 1.416-2.073 3.079-5.055 4.092-6.932.423-.783 1.538-.838 2.033-.1 1.201 1.793 3.162 4.658 4.741 6.662 1.524 1.933 3.723 4.374 5.251 6.03.679.736.182 1.942-.818 1.976"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m670.818 49.779 13.209-17.2a1.16 1.16 0 0 1 1.791-.058l14.252 16.264a1.16 1.16 0 0 1-.726 1.914l-13.635 1.733a1 1 0 0 1-.213.008l-13.825-.798a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "M700.795 57.969c-13.085 2.96-16.739 3.654-30.146 1.063a1.155 1.155 0 0 1-.624-1.925l6.144-6.505 8.098-9.113a1.16 1.16 0 0 1 1.705-.03l8.155 8.53 7.161 5.956c.739.614.444 1.812-.493 2.024"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M601.451 81.056a.773.773 0 0 1 .651-.79l3.862-.616a.773.773 0 0 1 .894.736l.245 7.167a.774.774 0 0 1-.746.799l-3.879.132a.773.773 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m619.502 51.126-32.653 1.114c-1.021.035-1.596-1.177-.927-1.95 2.267-2.616 6.171-7.245 8.645-10.867 2.436-3.567 5.346-8.88 6.804-11.614a1.185 1.185 0 0 1 2.027-.098c1.731 2.604 5.178 7.698 7.891 11.141 2.683 3.405 6.726 7.832 9.028 10.304.682.733.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m580.351 66.826 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.007l-22.511-1.298a1.159 1.159 0 0 1-.852-1.864"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M628.444 78.211c-21.528 4.875-26.77 6.026-48.75 1.701a1.156 1.156 0 0 1-.618-1.927l10.226-10.829 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.018 13.618 11.994 9.974c.739.615.45 1.81-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M515.924 106.904a.77.77 0 0 1 .65-.789l3.863-.618a.773.773 0 0 1 .894.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m533.974 76.974-32.653 1.114c-1.021.034-1.595-1.177-.926-1.95 2.267-2.616 6.171-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.732 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.727 7.831 9.028 10.304.682.732.186 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m494.823 92.674 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.483a1.159 1.159 0 0 1-.725 1.914l-22.206 2.824q-.106.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M542.916 104.059c-21.527 4.874-26.769 6.026-48.749 1.701a1.157 1.157 0 0 1-.619-1.928l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.705-.03L531.41 92.06l11.994 9.975c.739.614.45 1.81-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M654.028 70.234a.773.773 0 0 1 .65-.79l3.863-.617a.773.773 0 0 1 .894.737l.244 7.167a.77.77 0 0 1-.746.798l-3.879.133a.77.77 0 0 1-.798-.747z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m672.078 40.304-32.653 1.114c-1.021.034-1.595-1.177-.926-1.95 2.267-2.616 6.171-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.732 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.727 7.831 9.028 10.304.682.732.186 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m632.927 56.004 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.159 1.159 0 0 1-.725 1.913l-22.206 2.824q-.106.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M681.02 67.389c-21.527 4.874-26.769 6.026-48.749 1.701a1.156 1.156 0 0 1-.619-1.928l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.705-.03l13.018 13.617 11.994 9.975c.739.615.45 1.81-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M492.859 95.252a.773.773 0 0 1 .651-.79l3.862-.617a.773.773 0 0 1 .895.737l.244 7.166a.774.774 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m510.91 65.322-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.266-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.1c1.731 2.605 5.178 7.7 7.891 11.143 2.683 3.404 6.726 7.831 9.028 10.303.682.733.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m471.759 81.021 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.007l-22.511-1.299a1.159 1.159 0 0 1-.852-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M519.852 92.406c-21.528 4.875-26.77 6.027-48.75 1.701a1.156 1.156 0 0 1-.618-1.927l10.226-10.83 12.913-14.529a1.16 1.16 0 0 1 1.704-.03l13.019 13.617 11.993 9.974c.739.615.45 1.811-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M732.988 54.74a.77.77 0 0 1 .65-.79l2.545-.406a.773.773 0 0 1 .894.737l.171 5.016a.77.77 0 0 1-.746.798l-2.556.087a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m745.998 31.966-23.392.798c-1.021.035-1.595-1.18-.929-1.955 1.745-2.03 4.38-5.194 6.1-7.712 1.722-2.52 3.757-6.196 4.916-8.352a1.188 1.188 0 0 1 2.029-.1c1.374 2.057 3.778 5.586 5.697 8.02 1.87 2.374 4.615 5.404 6.395 7.328.68.734.184 1.94-.816 1.973"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m717.353 43.392 15.725-20.477a1.16 1.16 0 0 1 1.791-.058l16.968 19.362a1.16 1.16 0 0 1-.726 1.914l-16.234 2.064a1 1 0 0 1-.213.008l-16.458-.95a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M752.821 52.55c-15.64 3.54-19.781 4.372-35.784 1.256a1.155 1.155 0 0 1-.621-1.926l7.381-7.816 9.558-10.755a1.16 1.16 0 0 1 1.704-.031l9.63 10.073 8.626 7.174c.739.615.443 1.813-.494 2.025"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M543.654 109.328a.773.773 0 0 1 .651-.789l3.862-.617a.772.772 0 0 1 .894.736l.245 7.167a.773.773 0 0 1-.746.798l-3.879.133a.774.774 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m561.705 79.398-32.653 1.114c-1.021.035-1.595-1.177-.927-1.95 2.267-2.616 6.171-7.245 8.645-10.867 2.436-3.567 5.347-8.88 6.804-11.614a1.185 1.185 0 0 1 2.027-.099c1.731 2.605 5.178 7.7 7.891 11.142 2.683 3.405 6.726 7.832 9.028 10.304.682.733.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m522.554 95.098 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.007l-22.511-1.298a1.159 1.159 0 0 1-.852-1.864"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M570.647 106.483c-21.528 4.875-26.77 6.026-48.75 1.701a1.156 1.156 0 0 1-.618-1.927l10.226-10.829 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.018 13.618 11.994 9.974c.739.615.45 1.811-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M571.458 93.262a.77.77 0 0 1 .65-.79l3.862-.617a.774.774 0 0 1 .895.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m589.508 63.332-32.653 1.113c-1.021.035-1.595-1.176-.926-1.949 2.266-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.731 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.028 10.304.682.732.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m550.357 79.032 21.508-28.009a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.007l-22.511-1.298a1.159 1.159 0 0 1-.852-1.864"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M598.45 90.417c-21.528 4.874-26.769 6.026-48.749 1.7a1.156 1.156 0 0 1-.619-1.927l10.226-10.828 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.019 13.617 11.993 9.975c.739.614.45 1.81-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M324.057 133.071a.773.773 0 0 1 .651-.789l3.862-.618a.773.773 0 0 1 .894.737l.245 7.166a.773.773 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m342.108 103.141-32.653 1.113c-1.021.035-1.596-1.176-.927-1.949 2.267-2.616 6.171-7.246 8.645-10.868 2.436-3.566 5.346-8.88 6.804-11.613a1.185 1.185 0 0 1 2.027-.099c1.731 2.604 5.177 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.028 10.304.681.732.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m302.956 118.841 21.509-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.159 1.159 0 0 1-.726 1.913l-22.205 2.824a1 1 0 0 1-.213.007l-22.511-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M351.05 130.226c-21.528 4.874-26.77 6.026-48.75 1.701a1.156 1.156 0 0 1-.618-1.928l10.226-10.828 12.913-14.529a1.16 1.16 0 0 1 1.704-.031l13.018 13.617 11.994 9.975c.739.614.45 1.81-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M406.625 117.31a.774.774 0 0 1 .651-.79l3.862-.617a.774.774 0 0 1 .895.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m424.676 87.38-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.266-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.731 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.028 10.303.682.733.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m385.525 103.08 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.483a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.008l-22.511-1.299a1.159 1.159 0 0 1-.852-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M433.618 114.465c-21.528 4.874-26.769 6.026-48.749 1.701a1.156 1.156 0 0 1-.619-1.928l10.226-10.828 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.019 13.617 11.993 9.975c.739.614.45 1.81-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M443.646 108.215a.773.773 0 0 1 .65-.789l3.863-.618a.773.773 0 0 1 .894.737l.245 7.166a.773.773 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m461.697 78.285-32.653 1.114c-1.022.034-1.596-1.177-.927-1.95 2.267-2.616 6.171-7.246 8.645-10.868 2.436-3.566 5.346-8.88 6.804-11.613a1.185 1.185 0 0 1 2.027-.099c1.731 2.604 5.177 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.027 10.304.682.732.186 1.936-.814 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m422.545 93.985 21.509-28.008a1.16 1.16 0 0 1 1.791-.058l23.207 26.484a1.159 1.159 0 0 1-.725 1.913l-22.206 2.824q-.105.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M470.638 105.37c-21.527 4.874-26.769 6.026-48.749 1.701a1.156 1.156 0 0 1-.618-1.928l10.226-10.828 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.018 13.617 11.994 9.975c.739.614.45 1.811-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M387.48 88.887a.77.77 0 0 1 .65-.79l2.222-.354a.773.773 0 0 1 .894.736l.153 4.488a.773.773 0 0 1-.746.799l-2.231.076a.773.773 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m399.254 67.872-21.119.72c-1.021.035-1.596-1.18-.931-1.955 1.605-1.873 3.939-4.686 5.477-6.939 1.549-2.267 3.373-5.548 4.451-7.55.421-.783 1.539-.838 2.033-.098 1.278 1.91 3.431 5.06 5.157 7.251 1.674 2.125 4.11 4.822 5.75 6.597.68.735.182 1.94-.818 1.974"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m373.189 78.247 14.306-18.629a1.16 1.16 0 0 1 1.791-.058l15.436 17.615a1.16 1.16 0 0 1-.726 1.914l-14.768 1.878a1 1 0 0 1-.213.007l-14.973-.864a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "M405.559 86.859c-14.198 3.212-18.065 3.966-32.603 1.147-.893-.173-1.247-1.265-.623-1.926l6.683-7.076 8.735-9.829a1.16 1.16 0 0 1 1.705-.03l8.798 9.202 7.799 6.487c.739.615.443 1.812-.494 2.025"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M367.226 115.581a.774.774 0 0 1 .65-.79l3.863-.617a.773.773 0 0 1 .894.737l.245 7.166a.774.774 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m385.277 85.65-32.653 1.114c-1.021.035-1.596-1.177-.927-1.949 2.267-2.616 6.171-7.246 8.645-10.868 2.436-3.566 5.346-8.88 6.804-11.613a1.185 1.185 0 0 1 2.027-.099c1.731 2.604 5.177 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.027 10.303.682.733.186 1.936-.814 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m346.125 101.351 21.509-28.008a1.16 1.16 0 0 1 1.791-.058l23.207 26.483a1.159 1.159 0 0 1-.725 1.914l-22.206 2.823q-.105.014-.212.008l-22.511-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M394.218 112.735c-21.527 4.875-26.769 6.027-48.749 1.702a1.157 1.157 0 0 1-.618-1.928l10.226-10.828 12.913-14.53a1.16 1.16 0 0 1 1.704-.03l13.018 13.617 11.994 9.975c.739.614.45 1.81-.488 2.022"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M418.072 106.873a.774.774 0 0 1 .651-.79l1.971-.315a.774.774 0 0 1 .895.737l.139 4.08a.774.774 0 0 1-.746.799l-1.98.067a.77.77 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m428.89 87.215-19.362.66c-1.021.036-1.595-1.18-.932-1.957 1.493-1.746 3.596-4.29 4.995-6.339 1.416-2.073 3.079-5.055 4.093-6.932.422-.783 1.538-.838 2.033-.1 1.2 1.793 3.162 4.658 4.741 6.662 1.523 1.933 3.722 4.373 5.25 6.03.679.736.182 1.942-.818 1.976"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m404.82 96.779 13.208-17.2a1.16 1.16 0 0 1 1.791-.058l14.252 16.264a1.159 1.159 0 0 1-.725 1.914l-13.636 1.734q-.106.013-.213.007l-13.825-.798a1.159 1.159 0 0 1-.852-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "M434.795 104.969c-13.084 2.959-16.738 3.654-30.146 1.063-.893-.173-1.247-1.264-.623-1.925l6.144-6.505 8.098-9.113a1.16 1.16 0 0 1 1.705-.03l8.155 8.53 7.161 5.955c.739.615.444 1.813-.494 2.025"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M335.452 128.057a.77.77 0 0 1 .65-.79l3.863-.617a.773.773 0 0 1 .894.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m353.502 98.127-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.267-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.731 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.727 7.831 9.028 10.304.682.732.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m314.351 113.826 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.007l-22.51-1.298a1.16 1.16 0 0 1-.853-1.864"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M362.444 125.212c-21.527 4.874-26.769 6.026-48.749 1.701a1.157 1.157 0 0 1-.619-1.928l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.705-.03l13.018 13.617 11.994 9.975c.739.614.45 1.81-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M249.924 153.905a.774.774 0 0 1 .651-.79l3.862-.617a.772.772 0 0 1 .894.737l.245 7.166a.774.774 0 0 1-.746.799l-3.879.132a.774.774 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m267.975 123.974-32.653 1.114c-1.021.035-1.595-1.177-.927-1.949 2.267-2.616 6.171-7.246 8.645-10.868 2.436-3.567 5.347-8.881 6.805-11.614a1.184 1.184 0 0 1 2.026-.098c1.731 2.604 5.178 7.698 7.891 11.142 2.683 3.404 6.726 7.831 9.028 10.303.682.733.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m228.824 139.675 21.508-28.009a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.008l-22.511-1.299a1.159 1.159 0 0 1-.852-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M276.917 151.059c-21.528 4.875-26.77 6.026-48.75 1.701a1.156 1.156 0 0 1-.618-1.927l10.226-10.829 12.913-14.529a1.16 1.16 0 0 1 1.704-.031l13.018 13.618 11.994 9.974c.739.615.45 1.811-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M388.029 117.234a.77.77 0 0 1 .65-.789l3.863-.617a.772.772 0 0 1 .894.736l.244 7.167a.77.77 0 0 1-.746.798l-3.879.132a.77.77 0 0 1-.798-.745z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m406.079 87.304-32.653 1.114c-1.021.034-1.595-1.177-.926-1.95 2.267-2.616 6.171-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.732 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.727 7.832 9.028 10.304.682.732.186 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m366.928 103.004 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.158 1.158 0 0 1-.725 1.913l-22.206 2.824q-.106.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M415.021 114.389c-21.527 4.874-26.769 6.026-48.749 1.701a1.157 1.157 0 0 1-.619-1.928l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.705-.03l13.018 13.617 11.994 9.975c.739.615.45 1.811-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M226.86 142.251a.77.77 0 0 1 .65-.789l3.863-.617a.772.772 0 0 1 .894.736l.244 7.167a.77.77 0 0 1-.746.798l-3.879.133a.773.773 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m244.91 112.322-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.267-2.616 6.171-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.185 1.185 0 0 1 2.027-.1c1.731 2.605 5.177 7.7 7.89 11.143 2.683 3.405 6.727 7.831 9.028 10.303.682.733.186 1.936-.815 1.971"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m205.759 128.021 21.508-28.008a1.16 1.16 0 0 1 1.792-.058l23.207 26.484a1.16 1.16 0 0 1-.725 1.914l-22.206 2.823q-.106.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M253.852 139.406c-21.527 4.874-26.769 6.026-48.749 1.701a1.157 1.157 0 0 1-.619-1.928l10.227-10.828 12.912-14.529a1.16 1.16 0 0 1 1.705-.031l13.018 13.617 11.994 9.975c.739.615.45 1.811-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M466.988 101.74a.773.773 0 0 1 .651-.789l2.545-.407a.773.773 0 0 1 .894.737l.171 5.016a.77.77 0 0 1-.746.798l-2.556.087a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m479.998 78.966-23.391.798c-1.021.035-1.595-1.18-.929-1.955 1.745-2.03 4.38-5.194 6.1-7.712 1.721-2.52 3.757-6.196 4.915-8.352a1.19 1.19 0 0 1 2.03-.1c1.373 2.057 3.778 5.586 5.697 8.02 1.87 2.374 4.614 5.404 6.395 7.328.68.734.183 1.94-.817 1.973"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m451.354 90.392 15.725-20.477a1.16 1.16 0 0 1 1.791-.058l16.968 19.362a1.16 1.16 0 0 1-.726 1.914l-16.234 2.064a1 1 0 0 1-.213.007l-16.458-.95a1.16 1.16 0 0 1-.853-1.862"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M486.821 99.55c-15.639 3.539-19.78 4.372-35.783 1.256a1.155 1.155 0 0 1-.621-1.926l7.381-7.816 9.558-10.755a1.16 1.16 0 0 1 1.704-.031l9.63 10.073 8.626 7.174c.739.615.443 1.813-.495 2.025"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M277.655 156.329a.77.77 0 0 1 .65-.79l3.863-.617a.773.773 0 0 1 .894.737l.244 7.166a.77.77 0 0 1-.746.799l-3.879.132a.77.77 0 0 1-.798-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m295.705 126.399-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.267-2.616 6.171-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.732 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.727 7.831 9.028 10.303.682.733.186 1.937-.815 1.971"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m256.554 142.099 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.483a1.159 1.159 0 0 1-.725 1.914l-22.206 2.824q-.106.013-.213.007l-22.51-1.299a1.16 1.16 0 0 1-.853-1.863"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M304.647 153.484c-21.527 4.874-26.769 6.026-48.749 1.701a1.157 1.157 0 0 1-.619-1.928l10.227-10.828 12.912-14.53a1.16 1.16 0 0 1 1.705-.031l13.018 13.618 11.994 9.975c.739.614.45 1.81-.488 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M305.458 140.261a.774.774 0 0 1 .651-.789l3.862-.617a.774.774 0 0 1 .895.737l.244 7.166a.773.773 0 0 1-.746.799l-3.879.132a.774.774 0 0 1-.799-.746z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m323.509 110.332-32.653 1.113c-1.021.035-1.595-1.177-.926-1.949 2.266-2.616 6.17-7.246 8.644-10.868 2.436-3.566 5.347-8.88 6.805-11.613a1.184 1.184 0 0 1 2.026-.099c1.731 2.604 5.178 7.699 7.891 11.142 2.683 3.405 6.726 7.831 9.028 10.304.682.732.185 1.936-.815 1.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m284.358 126.031 21.508-28.008a1.16 1.16 0 0 1 1.791-.058l23.208 26.484a1.16 1.16 0 0 1-.726 1.914l-22.205 2.823a1 1 0 0 1-.213.007l-22.511-1.298a1.16 1.16 0 0 1-.852-1.864"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M332.451 137.416c-21.528 4.875-26.769 6.026-48.749 1.701a1.156 1.156 0 0 1-.619-1.927l10.226-10.829 12.913-14.529a1.16 1.16 0 0 1 1.704-.031l13.019 13.618 11.993 9.974c.739.615.45 1.811-.487 2.023"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M82.075 149.748a.77.77 0 0 1 .663-.778l2.913-.417a.772.772 0 0 1 .882.751l.1 5.606a.773.773 0 0 1-.759.787l-2.92.052a.77.77 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m96.864 125.254-25.937.463c-1.022.018-1.577-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.935-8.466 1.961-2.772 4.3-6.852 5.582-9.154a1.188 1.188 0 0 1 2.031-.066c1.44 2.238 4.062 6.232 6.152 8.975 2.047 2.687 5.087 6.145 6.983 8.257.669.745.152 1.94-.849 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m65.145 137.334 17.672-22.254a1.16 1.16 0 0 1 1.791-.029l18.327 21.612a1.16 1.16 0 0 1-.756 1.902l-17.903 1.982q-.106.011-.213.003l-18.096-1.339a1.16 1.16 0 0 1-.822-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M103.901 147.734c-17.31 3.624-21.768 4.472-39.35.739a1.156 1.156 0 0 1-.587-1.937l8.3-8.506 10.666-11.617a1.16 1.16 0 0 1 1.704-.003l10.377 11.214 9.417 8.094c.729.627.414 1.819-.527 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M150.21 137.885a.77.77 0 0 1 .663-.779l2.912-.417a.774.774 0 0 1 .883.751l.1 5.607a.774.774 0 0 1-.759.787l-2.919.052a.774.774 0 0 1-.787-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m164.999 113.391-25.937.463c-1.022.018-1.577-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.935-8.466 1.961-2.773 4.299-6.852 5.582-9.154a1.188 1.188 0 0 1 2.031-.066c1.44 2.238 4.062 6.232 6.152 8.974 2.047 2.688 5.087 6.145 6.983 8.258.669.744.152 1.94-.849 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m133.281 125.472 17.671-22.255a1.16 1.16 0 0 1 1.792-.029l18.327 21.613c.6.708.166 1.799-.757 1.901l-17.903 1.982q-.106.012-.213.004l-18.095-1.34a1.158 1.158 0 0 1-.822-1.876"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M172.036 135.871c-17.31 3.625-21.769 4.472-39.35.739a1.155 1.155 0 0 1-.587-1.936l8.299-8.507 10.666-11.616a1.16 1.16 0 0 1 1.705-.004l10.376 11.214 9.418 8.094c.729.627.414 1.819-.527 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M183.53 136.757a.773.773 0 0 1 .663-.779l2.913-.417a.773.773 0 0 1 .882.751l.1 5.607a.773.773 0 0 1-.759.787l-2.919.052a.77.77 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m198.319 112.263-25.937.463c-1.022.018-1.577-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.935-8.465 1.961-2.773 4.3-6.853 5.582-9.155a1.188 1.188 0 0 1 2.031-.065c1.441 2.238 4.062 6.231 6.152 8.974 2.048 2.687 5.087 6.145 6.983 8.257.669.745.152 1.94-.849 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m166.601 124.344 17.672-22.255a1.16 1.16 0 0 1 1.791-.029l18.327 21.613a1.158 1.158 0 0 1-.756 1.901l-17.903 1.982a1 1 0 0 1-.213.004l-18.096-1.34a1.158 1.158 0 0 1-.822-1.876"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M205.358 134.743c-17.311 3.625-21.769 4.472-39.351.739a1.155 1.155 0 0 1-.587-1.936l8.299-8.507 10.667-11.616a1.16 1.16 0 0 1 1.704-.004l10.377 11.214 9.417 8.094c.729.627.414 1.82-.526 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M137.351 126.058a.774.774 0 0 1 .663-.779l1.559-.223a.773.773 0 0 1 .882.751l.061 3.403a.773.773 0 0 1-.759.786l-1.562.028a.773.773 0 0 1-.787-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m146.858 108.815-16.443.293c-1.022.018-1.577-1.207-.903-1.975 1.323-1.504 3.083-3.58 4.28-5.272 1.225-1.733 2.662-4.199 3.589-5.845.437-.775 1.554-.811 2.038-.065 1.04 1.603 2.647 4.023 3.954 5.739 1.249 1.639 3.028 3.689 4.337 5.161.665.748.149 1.946-.852 1.964"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m125.977 116.689 11.62-14.634a1.16 1.16 0 0 1 1.792-.029l12.052 14.212c.6.709.166 1.8-.757 1.902l-11.772 1.303q-.106.012-.213.004l-11.9-.881a1.16 1.16 0 0 1-.822-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "M151.846 124.595c-11.277 2.357-14.581 2.897-26.071.5a1.154 1.154 0 0 1-.591-1.934l5.335-5.467 7.166-7.805a1.16 1.16 0 0 1 1.705-.004l6.964 7.526 6.014 5.169c.728.626.418 1.818-.522 2.015"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M118.529 145.757a.77.77 0 0 1 .663-.779l2.913-.417a.772.772 0 0 1 .882.751l.1 5.607a.77.77 0 0 1-.759.786l-2.919.052a.77.77 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m133.318 121.262-25.937.463c-1.022.018-1.577-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.936-8.465 1.96-2.773 4.299-6.853 5.581-9.155a1.188 1.188 0 0 1 2.031-.065c1.441 2.238 4.062 6.231 6.152 8.974 2.048 2.687 5.087 6.145 6.983 8.257.669.745.152 1.94-.849 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m101.6 133.343 17.672-22.254a1.158 1.158 0 0 1 1.791-.029l18.327 21.612c.601.708.167 1.8-.756 1.902l-17.903 1.981a1 1 0 0 1-.213.004l-18.096-1.339a1.16 1.16 0 0 1-.822-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M140.357 143.743c-17.311 3.624-21.769 4.471-39.351.738a1.155 1.155 0 0 1-.587-1.936l8.299-8.507 10.667-11.616a1.16 1.16 0 0 1 1.704-.003l10.377 11.213 9.417 8.095c.729.626.414 1.819-.526 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M164.41 142.973a.773.773 0 0 1 .663-.778l1.353-.194a.772.772 0 0 1 .882.751l.055 3.066a.773.773 0 0 1-.759.787l-1.356.024a.773.773 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m173.112 126.834-14.997.267c-1.021.019-1.577-1.207-.904-1.976 1.219-1.391 2.794-3.257 3.875-4.786 1.116-1.577 2.419-3.806 3.286-5.34.437-.774 1.556-.812 2.04-.066.972 1.496 2.428 3.683 3.619 5.246 1.13 1.483 2.725 3.327 3.935 4.69.664.749.147 1.947-.854 1.965"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m153.881 134.068 10.699-13.474a1.16 1.16 0 0 1 1.792-.029l11.096 13.085a1.16 1.16 0 0 1-.757 1.902l-10.838 1.2a1 1 0 0 1-.213.003l-10.957-.811a1.158 1.158 0 0 1-.822-1.876"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "M177.79 141.594c-10.362 2.164-13.485 2.658-24.052.463a1.152 1.152 0 0 1-.589-1.933l4.882-5.004 6.634-7.225a1.16 1.16 0 0 1 1.704-.003l6.444 6.964 5.496 4.723c.729.627.422 1.818-.519 2.015"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M91.514 145.775a.773.773 0 0 1 .663-.779l2.913-.417a.772.772 0 0 1 .882.751l.1 5.607a.77.77 0 0 1-.759.786l-2.919.052a.77.77 0 0 1-.786-.758z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m106.304 121.28-25.938.463c-1.021.018-1.576-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.936-8.466 1.96-2.772 4.3-6.852 5.581-9.154a1.188 1.188 0 0 1 2.032-.066c1.44 2.238 4.061 6.232 6.151 8.975 2.048 2.687 5.088 6.144 6.984 8.257.668.744.151 1.94-.849 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m74.585 133.361 17.672-22.254a1.16 1.16 0 0 1 1.792-.029l18.327 21.612c.6.708.166 1.8-.757 1.902l-17.903 1.981q-.106.013-.213.004l-18.095-1.339a1.16 1.16 0 0 1-.823-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M113.342 143.761c-17.31 3.624-21.769 4.471-39.35.738a1.155 1.155 0 0 1-.588-1.936l8.3-8.507L92.37 122.44a1.16 1.16 0 0 1 1.705-.004l10.376 11.214 9.418 8.094c.729.627.414 1.82-.527 2.017"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M20.81 165.896a.774.774 0 0 1 .662-.779l2.913-.417a.774.774 0 0 1 .882.752l.1 5.606a.773.773 0 0 1-.759.787l-2.919.052a.77.77 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m35.599 141.402-25.938.463c-1.021.018-1.576-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.936-8.466 1.96-2.772 4.299-6.852 5.581-9.154a1.188 1.188 0 0 1 2.032-.066c1.44 2.238 4.061 6.232 6.151 8.975 2.048 2.687 5.087 6.145 6.984 8.257.668.744.151 1.94-.85 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m3.88 153.483 17.67-22.254a1.158 1.158 0 0 1 1.793-.029l18.327 21.612c.6.708.166 1.8-.757 1.902l-17.903 1.981q-.106.012-.213.004L4.701 155.36a1.16 1.16 0 0 1-.822-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M42.637 163.882c-17.31 3.624-21.77 4.472-39.35.738a1.155 1.155 0 0 1-.588-1.936l8.3-8.507 10.666-11.616a1.16 1.16 0 0 1 1.705-.003l10.376 11.213 9.418 8.095c.729.627.414 1.819-.527 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M137.53 144.757a.773.773 0 0 1 .663-.779l2.913-.417a.773.773 0 0 1 .882.751l.1 5.607a.773.773 0 0 1-.759.787l-2.919.052a.77.77 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m152.319 120.263-25.937.463c-1.022.018-1.577-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.935-8.466 1.961-2.773 4.3-6.852 5.582-9.154.433-.777 1.55-.814 2.031-.066 1.441 2.238 4.062 6.232 6.152 8.974 2.048 2.688 5.087 6.145 6.983 8.258.669.744.152 1.94-.849 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m120.601 132.344 17.672-22.255a1.16 1.16 0 0 1 1.791-.029l18.327 21.613a1.158 1.158 0 0 1-.756 1.901l-17.903 1.982a1 1 0 0 1-.213.004l-18.096-1.34a1.158 1.158 0 0 1-.822-1.876"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M159.358 142.743c-17.311 3.624-21.769 4.471-39.351.738a1.155 1.155 0 0 1-.587-1.936l8.299-8.507 10.667-11.616a1.16 1.16 0 0 1 1.704-.003l10.377 11.213 9.417 8.095c.729.626.414 1.819-.526 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M19.791 153.694a.594.594 0 0 1 .509-.598l2.234-.319a.592.592 0 0 1 .677.576l.076 4.3a.59.59 0 0 1-.582.603l-2.239.04a.59.59 0 0 1-.603-.582z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m31.136 134.906-19.895.356c-.783.014-1.209-.924-.688-1.509 1.48-1.663 3.808-4.356 5.32-6.493 1.504-2.127 3.297-5.256 4.28-7.022a.91.91 0 0 1 1.559-.05c1.105 1.717 3.115 4.78 4.718 6.883 1.57 2.061 3.902 4.713 5.357 6.334.512.571.116 1.488-.651 1.501"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m6.806 144.172 13.554-17.069a.89.89 0 0 1 1.374-.022l14.057 16.577a.89.89 0 0 1-.58 1.459l-13.732 1.519a1 1 0 0 1-.163.003l-13.88-1.027a.89.89 0 0 1-.63-1.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M36.533 152.149c-13.278 2.78-16.697 3.43-30.182.566a.886.886 0 0 1-.45-1.485l6.365-6.524 8.181-8.91a.89.89 0 0 1 1.308-.003l7.958 8.601 7.224 6.209c.559.48.317 1.395-.404 1.546"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M202.569 137.761a.77.77 0 0 1 .663-.779l1.825-.262a.774.774 0 0 1 .883.752l.068 3.836a.773.773 0 0 1-.759.787l-1.83.032a.773.773 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m213.117 119.087-18.314.327c-1.022.018-1.577-1.207-.902-1.973 1.451-1.645 3.456-3.998 4.803-5.903 1.368-1.935 2.98-4.711 3.982-6.496.436-.775 1.553-.813 2.036-.066 1.125 1.738 2.928 4.461 4.388 6.377 1.404 1.842 3.425 4.164 4.858 5.771.666.747.15 1.945-.851 1.963"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m190.099 127.79 12.813-16.135a1.16 1.16 0 0 1 1.792-.029l13.288 15.67a1.16 1.16 0 0 1-.757 1.902l-12.98 1.436q-.106.013-.213.004l-13.121-.971a1.16 1.16 0 0 1-.822-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M218.506 136.188c-12.461 2.606-15.997 3.206-28.684.547-.89-.187-1.227-1.284-.591-1.935l5.918-6.067 7.857-8.555a1.16 1.16 0 0 1 1.704-.004l7.636 8.253 6.685 5.745c.729.627.416 1.819-.525 2.016"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M44.699 150.097a.594.594 0 0 1 .508-.598l2.234-.32c.353-.05.67.22.677.577l.077 4.3a.593.593 0 0 1-.582.603l-2.24.04a.593.593 0 0 1-.603-.582z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m56.043 131.309-19.895.355c-.783.014-1.209-.923-.688-1.508 1.481-1.663 3.809-4.356 5.32-6.493 1.504-2.127 3.298-5.256 4.281-7.022a.91.91 0 0 1 1.558-.05c1.105 1.716 3.115 4.779 4.718 6.883 1.571 2.061 3.902 4.713 5.357 6.333.513.572.116 1.489-.651 1.502"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m31.713 140.575 13.554-17.069a.89.89 0 0 1 1.375-.022l14.056 16.577a.888.888 0 0 1-.58 1.458l-13.732 1.52a1 1 0 0 1-.163.003l-13.88-1.027a.89.89 0 0 1-.63-1.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M61.44 148.552c-13.278 2.78-16.697 3.43-30.182.566a.886.886 0 0 1-.45-1.485l6.365-6.525 8.181-8.909a.89.89 0 0 1 1.308-.003l7.959 8.601 7.223 6.209c.559.48.317 1.395-.404 1.546"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M66.677 155.415a.77.77 0 0 1 .663-.778l2.913-.417a.772.772 0 0 1 .882.751l.1 5.606a.773.773 0 0 1-.758.787l-2.92.052a.77.77 0 0 1-.786-.759z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m81.467 130.921-25.938.463c-1.021.018-1.576-1.204-.897-1.967 1.93-2.168 4.965-5.679 6.936-8.466 1.96-2.772 4.3-6.852 5.582-9.154a1.188 1.188 0 0 1 2.03-.066c1.441 2.238 4.062 6.232 6.152 8.975 2.048 2.687 5.088 6.145 6.984 8.257.668.745.152 1.94-.85 1.958"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m49.748 143.001 17.672-22.254a1.16 1.16 0 0 1 1.792-.029l18.327 21.612c.6.709.166 1.8-.757 1.902l-17.903 1.982q-.106.011-.213.003l-18.095-1.339a1.16 1.16 0 0 1-.823-1.877"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M88.504 153.401c-17.31 3.624-21.769 4.472-39.35.739a1.156 1.156 0 0 1-.588-1.937l8.3-8.506 10.666-11.617a1.16 1.16 0 0 1 1.705-.003l10.376 11.214 9.418 8.094c.729.627.414 1.819-.527 2.016"
		})
	]
});
export default SvgForestRight;
